import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b03f045"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stat" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  class: "inline-number",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "subtext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.number), 1),
    _createElementVNode("h4", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.number), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.subtext), 1)
  ]))
}